export default __webpack_public_path__ + "assets/etsy.8fb38ac0.svg";